
app.service('topModal', function () {
	var $self;

	function generate({ content = '', header = '', cssClass = '', close = true }) {
		closeModal();
		$self = $(`
			<div id="top-modal" class="${cssClass}">
				<div id="top-modal-content">
					<div id="top-modal-header">${header}</div> 
					${content}
				</div>
			</div>
		`);
		if (close) {
			$self.on('click', function () {
				closeModal();
			});
		}
		$('body').append($self);
	}
	function closeModal() { 
		if ($self && $self.length) {
			$self.remove();
		}
	}
	return {
		generate, close: closeModal
	};
});
